const ArrowBack = (props: any) => {

  return (
    <svg {...props} width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.72067 16.3802L2.30249 9L9.72067 1.61976C10.0931 1.24922 10.0931 0.648444 9.72066 0.277904C9.3482 -0.0926368 8.74434 -0.0926349 8.37189 0.277911L0.279335 8.32907C-0.0931128 8.69962 -0.0931128 9.30038 0.279335 9.67092L8.37189 17.7221C8.74434 18.0926 9.3482 18.0926 9.72066 17.7221C10.0931 17.3516 10.0931 16.7508 9.72067 16.3802Z"
        fill="#909090"/>
    </svg>

  )
}

export default ArrowBack;const ArrowBack = (props: any) => {

  return (
    <svg {...props} width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.72067 16.3802L2.30249 9L9.72067 1.61976C10.0931 1.24922 10.0931 0.648444 9.72066 0.277904C9.3482 -0.0926368 8.74434 -0.0926349 8.37189 0.277911L0.279335 8.32907C-0.0931128 8.69962 -0.0931128 9.30038 0.279335 9.67092L8.37189 17.7221C8.74434 18.0926 9.3482 18.0926 9.72066 17.7221C10.0931 17.3516 10.0931 16.7508 9.72067 16.3802Z"
        fill="#909090"/>
    </svg>

  )
}

export default ArrowBack;